module.exports = __webpack_public_path__ + "static/img/letter_medium@2x.a2d3940.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/birthday/letter_medium@2x.png
// module id = OfOn
// module chunks = 1